import { createSlice } from "@reduxjs/toolkit";

export const mainSlice = createSlice({
  name: 'main',
  initialState: {
    data: {
      pilots: [],
      mairies: [],
      cities: [],
      userRoles: [],
      districts: [],
      missionSubjects: [],
      billingTypes: [],
      validationPage: null,
      missionBillings: [],
      languages: [{ value: 'fr', label: 'FR' }, { value: 'es', label: 'ES' }, { value: 'en', label: 'EN' }]
    },
    dynamicFormType: null,
    dynamicFormObject: {},
    dynamicStore: '',
    initialied: false,
    mission: {},
    homePage: null,
    currentPage: null,
    token: '',
    logguedUser: null,
    notification: null,
    vueType: 'desktop'
  },
  reducers: {
    initMain: (state, action) => {
      return { ...state, mission: { ...action.payload }, initialied: true }
    },
    updateData: (state, action) => {
      state.data = { ...state.data, ...action.payload }
    },
    updateVueType: (state, action) => {
      state.vueType = action.payload
    },
    updateNotification: (state, action) => {
      state.notification = action.payload
    },
    updateToken: (state, action) => {
      state.token = action.payload
    },
    initDynamicForm: state => {
      return { ...state, dynamicFormType: null, dynamicFormObject: {}, dynamicStore: null }
    },
    updateFormType: (state, action) => {
      const { dynamicFormType, dynamicFormObject, dynamicStore } = action.payload
      return { ...state, dynamicFormType, dynamicFormObject, dynamicStore }
    },
    updateDynamicFormObject: (state, action) => {
      state.dynamicFormObject = action.payload
    },
    updateValidationPage: (state, action) => {
      state.validationPage = action.payload
    },
    mainFullUpdate: (state, action) => {
      return { ...state, ...action.payload }
    }
  }
})

export const {
  initMain,
  updateFormType,
  updateDynamicFormObject,
  initDynamicForm,
  updateData,
  mainFullUpdate,
  updateNotification,
  updateValidationPage,
  updateVueType
} = mainSlice.actions

export default mainSlice.reducer